export default __webpack_public_path__ + "static/media/03.a67833b2.jpeg";